import { apiFetch } from './client.js';

export async function sendTelemetry(deviceId, payload) {
  return apiFetch(`/devices/${deviceId}/telemetry`, {
    method: 'POST',
    body: payload,
    silent: true,
  });
}
